import Header from '../../../../Components/Header'
import MainContent from './MainContent'
import { Helmet } from 'react-helmet'

const ItemListDualView = () => {

    return (
        <div className='d-flex flex-column' style={{ minHeight: '99.7vh' }}>
            <Helmet>
                <title>Item List</title>
            </Helmet>
            <Header />
            <MainContent />
        </div>
    )
}

export default ItemListDualView